<template>
	<app-page>
		<app-heading title="Leads">
			<template v-slot:right>
				<app-button
					outlined
					small
					color="secondary"
					icon="fa-sync"
					@click="refresh = true"
				>Refresh</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="leads"
					:total="count"
					:refresh.sync="refresh"
					:headers="headers"
					:sort-by="'_id'"
					:sort-desc="true"
					@update="fetchLeads"
				>
					<template v-slot:studeo_id="{ item }">
						<span v-if="item.studeo_id">{{ item.studeo_id }}</span>
						<span v-else class="warning--text">Not defined</span>
					</template>
					<template v-slot:resort="{ item }">
							<div>{{ item.resort? item.resort.name : 'N/A' }}</div>
							<div>
								<i>{{ item.source }}</i>
							</div>
					</template>
					<template v-slot:status="{ item }">
							<span v-if="item.status === 0" class="primary--text">Pending</span>
							<span v-if="item.status === 1" class="success--text">Success</span>
							<span v-if="item.status === 2" class="error--text">Error</span>
							<span v-if="item.status === 3" class="warning--text">Warning</span>
					</template>
					<template v-slot:error="{ item }">
							<span
								v-if="item.error"
							>
								<app-tooltip :text="item.error">
									{{ item.error.substr(0, 50) }}
									<span v-if="item.error.length > 50">...</span>
								</app-tooltip>
							</span>
							<span v-else>N/A</span>
					</template>
					<template v-slot:actions="{ item }">
						<app-button
							color="secondary"
							icon="fa-sync"
							table
							@click="retryLead(item)"
							:disabled="item.status !== 2"
							:loading="retrying[item._id]"
						>
							Retry
						</app-button>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			leads: [],
			retrying: {},
			count: -1,
			refresh: false,
			headers: [{
				text: 'Created',
				value: '_id',
				sortable: true,
				format: 'datetime',
			}, {
				text: 'Studeo ID',
				value: 'studeo_id',
				sortable: true,
			}, {
				text: 'Email',
				value: 'customer.email',
				sortable: true,
			}, {
				text: 'Subject',
				value: 'subject',
				sortable: true,
			}, {
				text: 'Resort',
				value: 'resort',
				sortable: false,
			}, {
				text: 'Status',
				value: 'status',
				sortable: true,
			}, {
				text: 'Error',
				value: 'error',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},

	methods: {
		async fetchLeads(pagination) {
			const request = this.$ravello.graphql('leads')
				.fields([
					'_id',
					'studeo_id',
					'status',
					'subject',
					'status',
					'source',
					'error',
				])
				.include(this.$ravello.graphql('customer').field('email'))
				.include(this.$ravello.graphql('resort').field('name'))
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.leads = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async retryLead(lead) {
			this.retrying = { ...this.retrying, [lead._id]: true }
			try {
				const res = await this.$ravello.request()
					.v(2)
					.to('leads')
					.to(lead._id)
					.to('retry')
					.create()

				lead.status = res.status
				lead.error = res.error
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}

			this.retrying[lead._id] = false
		},
	},
}
</script>
